<!--
 * @Author: DY
 * @Date: 2021-05-20 13:55:20
 * @LastEditTime: 2026-08-05 14:02:14
 * @LastEditors: DY
 * @Description: In User Settings Edit
 * @FilePath: \ProjectTree_vue2\ConcreteCloud_Web\src\views\productionManagement\productionDeliverGoodsJournal\logList.vue
-->
<template>
    <div class="shippingLogList" v-loading="loading">
        <div class="header">
            <h4>混凝土生产原始记录</h4>
            <div class="qRCode iconfont iconerweima" @click="generateQRcode"></div>
        </div>
        <div class="shippingLogList_content" id="out-table">
            <div class="essentialInfo">
                <table class="border_table">
                    <thead>
                        <tr>
                            <th>发货时间：</th>
                            <td colspan="2">
                                {{ essentialInfo.deliver_time||'-' }}
                            </td>
                            <th>生产站点：</th>
                            <td colspan="2">
                                {{ essentialInfo.mixstation_name||'-' }}
                            </td>
                            <th>生产机组：</th>
                            <td>{{ essentialInfo.line_name||'-' }}</td>
                            <th>任务单号：</th>
                            <td>{{ essentialInfo.task_number||'-' }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>合同单位</th>
                            <td colspan="7">
                                {{ essentialInfo.customer_name||'-' }}
                            </td>
                            <th>发货单号</th>
                            <td>{{ essentialInfo.pcb_number||'-' }}</td>
                        </tr>
                        <tr>
                            <th>工程名称</th>
                            <td colspan="7">
                                {{ essentialInfo.project_name||'-' }}
                            </td>
                            <th rowspan="2">
                                生产时间
                            </th>
                            <td title="生产时间开始时间">
                                {{ essentialInfo.product_time||'-' }}
                            </td>
                        </tr>
                        <tr>
                            <th>施工部位：</th>
                            <td colspan="5">
                                {{ essentialInfo.place_detail||'-' }}
                            </td>
                            <th>气    温：</th>
                            <td>{{ essentialInfo.temperature ||'-' }}</td>
                            <td title="生产时间结束时间">
                                {{ essentialInfo.product_complete_time||'-' }}
                            </td>
                        </tr>
                        <tr>
                            <th>砼等级：</th>
                            <td>{{ essentialInfo.strength_grade_name||'-' }}</td>
                            <th>坍落度：</th>
                            <td>{{ essentialInfo.slump }}±{{ essentialInfo.slump_name }}</td>
                            <th>浇筑方式：</th>
                            <td>{{ essentialInfo.pouring_name||'-' }}</td>
                            <th>运  距：</th>
                            <td>{{ essentialInfo.haul_distance||'-' }}</td>
                            <th>车辆皮重：</th>
                            <td>{{ essentialInfo.tare_weight||'-' }} kg</td>
                        </tr>
                        <tr>
                            <th>附加型号：</th>
                            <td colspan="3">
                                {{ essentialInfo.special_require_name||'-' }}
                            </td>
                            <th>运输车号：</th>
                            <td>{{ essentialInfo.shch||'-' }}</td>
                            <th>驾驶员：</th>
                            <td>{{ essentialInfo.sjxm||'-' }}</td>
                            <th>出场毛重：</th>
                            <td>{{ essentialInfo.gross_weight||'-' }} kg</td>
                        </tr>
                        <tr>
                            <th>配比编号：</th>
                            <td colspan="3">
                                {{ essentialInfo.product_formula_number||'-' }}
                            </td>
                            <th>累计车次：</th>
                            <td>{{ essentialInfo.grand_total_vehicles }}</td>
                            <th>机操员：</th>
                            <td>{{ essentialInfo.sign_product||'-' }}</td>
                            <th>出场净重：</th>
                            <td>{{ essentialInfo.net_weight||'-' }} kg</td>
                        </tr>
                        <tr>
                            <th>生产方量：</th>
                            <td>{{ essentialInfo.filled_volume||'-' }}</td>
                            <th>其他方量：</th>
                            <td>{{ essentialInfo.qtfl ||'-' }}</td>
                            <th>签收方量：</th>
                            <td>{{ essentialInfo.sign_volume||'-' }}</td>
                            <th>质检员：</th>
                            <td>{{ essentialInfo.sign_formula||'-' }}</td>
                            <th>过磅容重：</th>
                            <td>{{ essentialInfo.gbrz||'-' }} kg</td>
                        </tr>
                        <tr>
                            <th>发货方量：</th>
                            <td>{{ essentialInfo.volume||'-' }}</td>
                            <th>是否剩退：</th>
                            <td>{{ essentialInfo.handle_style?'是':'否' }}</td>
                            <th>处置方式：</th>
                            <td>{{ essentialInfo.handle_style_name||'-' }}</td>
                            <th>调度员：</th>
                            <td>{{ essentialInfo.sign_off||'-' }}</td>
                            <th>配比容重：</th>
                            <td>{{ essentialInfo.volume_weight||'-' }} kg</td>
                        </tr>
                        <tr>
                            <th>关联发货单：</th>
                            <td colspan="3">
                                <span v-if="target_pcb_number" class="link-text" @click="viewRelationPcb(target_pcb_number)">
                                    {{ target_pcb_number }}
                                </span>
                                <span v-else>-</span>
                            </td>
                            <th>转发型号：</th>
                            <td>{{ essentialInfo.zfxh ||'-' }}</td>
                            <th>发货状态：</th>
                            <td>{{ getPcbStatusName(essentialInfo.pcbstate)||'-' }}</td>
                            <th>实际容重：</th>
                            <td>{{ essentialInfo.unit_weight||'-' }} kg</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="printingData">
                <table class="border_table">
                    <tbody>
                        <tr>
                            <th rowspan="4">
                                盘次
                            </th>
                            <th>原材料</th>
                            <template v-for="(item, index) in tableHeader">
                                <td :key="index" :colspan="item.modelItems.length">
                                    {{ item.title }}
                                </td>
                            </template>
                        </tr>
                        <tr>
                            <th>规格</th>
                            <template v-for="(item, index) in orderDictionary">
                                <td :key="index">
                                    {{ item.value }}
                                </td>
                            </template>
                        </tr>
                        <tr>
                            <th>单方配合比</th>
                            <template v-for="(item, index) in orderDictionary">
                                <td :key="index">
                                    {{ item.formula_value }}
                                </td>
                            </template>
                        </tr>
                        <tr>
                            <th>单方消耗用量</th>
                            <template v-for="(item, index) in orderDictionary">
                                <td :key="index">
                                    {{ item.avg_consume_value }}
                                </td>
                            </template>
                        </tr>
                        <template v-for="(item, index) in diskData">
                            <tr :key="`pc_${index}`">
                                <th rowspan="2">
                                    盘次：{{ item.pc }}
                                </th>
                                <td>配比值</td>
                                <td v-for="(k, i) in orderDictionary" :key="`pcs_${i}`">
                                    {{ item.recordset[k.name] ? item.recordset[k.name][0] : '-' }}
                                </td>
                            </tr>
                            <tr :key="`sd_${index}`">
                                <td>设定值</td>
                                <td v-for="(k, i) in orderDictionary" :key="`pcs_${i}`">
                                    {{ item.recordset[k.name] ? item.recordset[k.name][1] : '-' }}
                                </td>
                            </tr>
                            <tr :key="`duration_${index}`">
                                <th>搅拌时间：{{ item.duration }}s</th>
                                <td>称量值</td>
                                <td v-for="(k, i) in orderDictionary" :key="`durations_${i}`">
                                    {{ item.recordset[k.name] ? item.recordset[k.name][2] : '-' }}
                                </td>
                            </tr>
                            <tr :key="`cpfl_${index}`" class="line">
                                <th>搅拌方量：{{ item.cpfl }}</th>
                                <td>误差%</td>
                                <td
                                    v-for="(k, i) in orderDictionary"
                                    :key="`cpfls_${i}`"
                                    :class="{'hight-cell':item.recordset[k.name]?item.recordset[k.name][4]=='1':false}"
                                >
                                    {{ item.recordset[k.name] ? item.recordset[k.name][3] : '-' }}
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <th rowspan="3">
                                累计
                            </th>
                            <td>
                                {{ essentialInfo.is_theory === 1 ? '设定值': '配比值' }}
                            </td>
                            <template v-for="(k, i) in orderDictionary">
                                <td :key="`total1_${i}`">
                                    {{ totalMap[k.name][0] }}
                                </td>
                            </template>
                        </tr>
                        <tr>
                            <td>
                                称量值
                            </td>
                            <template v-for="(k, i) in orderDictionary">
                                <td :key="`total2_${i}`">
                                    {{ totalMap[k.name][1] }}
                                </td>
                            </template>
                        </tr>
                        <tr>
                            <td>
                                误差%
                            </td>
                            <template v-for="(k, i) in orderDictionary">
                                <td :key="`total3_${i}`" :class="{'hight-cell':totalMap[k.name]?totalMap[k.name][3]=='1':false}">
                                    {{ totalMap[k.name][2] }}
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="bottom_info">
                <table>
                    <tbody>
                        <!--<tr>-->
                        <!--    <th>【来自】发货单：</th>-->
                        <!--    <td>-->
                        <!--        <span-->
                        <!--            v-if="essentialInfo.turn_pcb_number || essentialInfo.transfer_turn_pcb_number"-->
                        <!--            class="link-text"-->
                        <!--            @click="viewRelationPcb(essentialInfo.turn_pcb_number || essentialInfo.transfer_turn_pcb_number)"-->
                        <!--        >-->
                        <!--            {{ essentialInfo.turn_pcb_number || essentialInfo.transfer_turn_pcb_number }}-->
                        <!--        </span>-->
                        <!--        <span v-else>-</span>-->
                        <!--    </td>-->
                        <!--    <th>【转发】发货单：</th>-->
                        <!--    <td>-->
                        <!--        <span-->
                        <!--            v-if="essentialInfo.back_pcb_number || essentialInfo.transfer_back_pcb_number"-->
                        <!--            class="link-text"-->
                        <!--            @click="viewRelationPcb(essentialInfo.back_pcb_number || essentialInfo.transfer_back_pcb_number)"-->
                        <!--        >-->
                        <!--            {{ essentialInfo.back_pcb_number || essentialInfo.transfer_back_pcb_number }}-->
                        <!--        </span>-->
                        <!--        <span v-else>-</span>-->
                        <!--    </td>-->
                        <!--    <th>【来自】转机组：</th>-->
                        <!--    <td>-->
                        <!--        {{ essentialInfo.changed_line_name||'-' }}-->
                        <!--    </td>-->
                        <!--</tr>-->
                        <tr>
                            <th>到达工地时间：</th>
                            <td>
                                {{ essentialInfo.arrival_time||'-' }}
                            </td>
                            <th>开始卸料时间：</th>
                            <td>
                                {{ essentialInfo.unload_time||'-' }}
                            </td>
                            <th>结束卸料时间：</th>
                            <td>
                                {{ essentialInfo.unload_over_time||'-' }}
                            </td>
                        </tr>
                        <tr>
                            <th>回厂时间：</th>
                            <td>
                                {{ essentialInfo.into_time||'-' }}
                            </td>
                            <th>回厂皮重：</th>
                            <td>
                                {{ essentialInfo.back_gross_weight||'-' }}
                            </td>
                            <th>回厂净重：</th>
                            <td>
                                {{ essentialInfo.back_net_weight||'-' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <footer>
            <el-button @click="exportData" v-if="isExport">
                导出
            </el-button>
            <el-button @click="cancel">
                关闭
            </el-button>
            <el-button @click="closeAll" v-if="extr.openList">
                全部关闭
            </el-button>
        </footer>
        <el-dialog
            title="扫描二维码"
            :visible.sync="dialogVisible"
            append-to-body
            width="240px"
            :before-close="handleClose"
            custom-class="qrCodeDivDialog"
        >
            <div id="qrCode" ref="qrCodeDiv"></div>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import utils from '@/utils/util';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    // 生产发货日志列表
    name: 'shipping-log-list',
    components: {},
    props: {
        extr: {
            type: [Object],
        },
    },
    data() {
        return {
            // 是否有导出按钮
            isExport: true,
            loading: false,
            isReload: true,
            // 基本信息数据
            essentialInfo: {},
            // 打料数据
            printingData: {},
            // 打料列表表头数据
            tableHeader: [],
            // 打料列表循环字典
            orderDictionary: [],
            // 打料列表配比值数据
            formulaValues: {},
            // 打料列表盘次数据
            diskData: [],
            // 关联单号
            target_pcb_number: '',

            // 二维码弹出
            dialogVisible: false,

            // 累计数据
            totalMap: {},

        };
    },
    computed: {},
    watch: {},
    created() {
        this.isExport = this.extr.tenantid ? false : true;
        // 初始化数据
        this.getInitData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 关闭出层
        cancel() {
            this.$parent.hide();
        },
        closeAll() {
            this.$parent.hide();
            (this.extr.openList || []).forEach(item => {
                item.hide();
            });
        },
        // 初始化数据
        getInitData() {
            this.loading = true;
            let url = `/interfaceApi/production/productrecord/recordset/${this.extr.pcb_number}`;
            if (this.extr.tenantid) {
                url = `${url}?tenantid=${this.extr.tenantid}`;
            }
            this.$axios
                .get(url)
                .then(res => {
                    if (res) {
                        this.target_pcb_number = res.target_pcb_number;
                        this.essentialInfo = res.recordInfo;
                        if (res.recordConsumes) {
                            this.printingData = res.recordConsumes;
                            if (res.recordConsumes.recordConsumesHeader) {
                                if (res.recordConsumes.recordConsumesHeader.recordHeaders) {
                                    this.tableHeader = res.recordConsumes.recordConsumesHeader.recordHeaders;
                                    const row = [];
                                    this.tableHeader.forEach(item => {
                                        row.push(...item.modelItems);
                                    });
                                    row.forEach(item => {
                                        this.orderDictionary.push({
                                            name: item.name,
                                            value: item.value,
                                            formula_value: item.formula_value,
                                            avg_consume_value: item.avg_consume_value,
                                        });
                                    });
                                }
                                if (res.recordConsumes.recordConsumesHeader.formulaValues) {
                                    this.formulaValues = res.recordConsumes.recordConsumesHeader.formulaValues;
                                }
                            }
                            if (res.recordConsumes.recordConsumesEntity) {
                                if (res.recordConsumes.recordConsumesEntity.plate_record_consumes) {
                                    this.diskData = res.recordConsumes.recordConsumesEntity.plate_record_consumes;
                                }
                                if (res.recordConsumes.recordConsumesEntity.grand_total_record_consume) {
                                    this.totalMap = res.recordConsumes.recordConsumesEntity.grand_total_record_consume;
                                }
                            }
                        }
                    } else if (this.isReload) {
                        this.isReload = false;
                        this.getInitData();
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 生成二维码
        generateQRcode() {
            this.dialogVisible = true;
            this.$nextTick(() => {
                new QRCode(this.$refs.qrCodeDiv, {
                    text: this.essentialInfo.pcb_number || '',
                    width: 200,
                    height: 200,
                    colorDark: '#333333', // 二维码颜色
                    colorLight: '#ffffff', // 二维码背景色
                    correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
                });
            });
        },
        // 查看关联发货单
        viewRelationPcb(pcb_nubmer) {
            const openList = [...this.extr.openList || []];
            openList.push(this.$parent);
            this.$toast({
                title: true,
                text: '业务信息',
                type: 'eject',
                width: '80%',
                height: '90%',
                t_url: 'productionManagement/productionDeliverGoodsJournal/logList',
                extr: {
                    pcb_number: pcb_nubmer,
                    openList: openList,
                },
            });
        },
        // 关闭二维码弹出层
        handleClose(done) {
            done();
            this.$('#qrCode').html('');
        },
        // 后端导出数据
        exportData() {
            this.loading = true;
            this.$exportExcel({
                requestUrl: `/interfaceApi/production/productrecord/recordset/export/${this.extr.pcb_number}`,
                exportMethod: 'post',
            });
            this.loading = false;
        },

        // 获取发货状态名称
        getPcbStatusName(status) {
            const m = {
                5: '已接单',
                8: '已生产',
                9: '生产完成',
                3: '已签收',
            };
            return m[status] || '-';
        },
    },
};
</script>
<style lang="stylus" scoped>
.shippingLogList
    height 100%
    padding 20px
    .header
        height 44px
        position relative
        margin-bottom 14px
        h4
            font-size 20px
            line-height 44px
            text-align center
            color #333333

        .qRCode
            width 44px
            height 44px
            position absolute
            right 0
            top 0
            font-size 38px
            cursor pointer
    .shippingLogList_content
        height calc(100% - 110px)
        overflow-x hidden
        overflow-y auto
        table
            width calc(100% - 2px)
            box-sizing border-box
            border-collapse collapse
            th,td
                font-size 14px
                height 36px
                font-weight 400
            th
                color #002B94
                width 150px
            td
                color #333333
                width 350px
                .link-text
                    color: blue;
                    text-decoration: underline;
                    cursor: pointer;
            &.border_table
                tbody
                    th,td
                        border 1px solid #D7D7D7
                        th
                            background #F6F8FC
            .hight-cell
                background: #FFF1F0;
        .essentialInfo
            tbody
                th
                    background #F6F8FC
            td
                padding 3px 10px
                .unit
                    color #7D7D7D
                    float right
                    margin-right 14px
        .printingData
            margin-top 15px
            table
                width 100%
                th,td
                    text-align center
                    border 1px solid #D7D7D7
                th
                    background #F6F8FC
                td
                    width 100px
                    table
                        td,th
                            border-top none
                            border-right none
                            &:first-child
                                border-left none
                        tr
                            &:last-child
                                td,th
                                    border-bottom none
                tbody
                    tr
                        &.line
                            th,td
                                border-bottom 1px solid #979EA7
            >table
                >tbody
                    >th
                        border-left 1px solid #979EA7
                    >td
                        &:last-child
                            border-right 1px solid #979EA7
            .total-th
                height 100%;
                display flex
                justify-content center
                align-items center
                border-top: 1px solid #979ea7
    footer
        width 100%
        position absolute
        bottom 20px
        left 0
        text-align center
        .el-button
            width 200px
            padding 0
            font-size 16px
            line-height 40px
            margin 0 20px
            height 40px
/deep/ .qrCodeDivDialog
            .el-dialog__body
                padding 10px 20px 20px
</style>
